<template>
	<div class="tab-top">
		<div class="tab-content-tab">
			<div class="tabs-bg">
				<div class="tabs-itemsss" v-for="(item, index) in tabList" :key="index" @click="OntoTab(item.st)" :class="[selectIndex == item.st ? 'selected' : '']">
					<div class="iconfont" :class="[item.iconfont]"></div>
					<div class="item-rec">{{ item.name }}</div>
				</div>
			</div>
		</div>
		<div class="tab-content-tabs">
			<div class="tabs-bg">
				<div class="tabs-item" :class="[mapSelectindex == 1 ? 'selected' : '']" @click="onselectMap()">
					<div class="iconfont icon-weixing"></div>
					<div class="item-rec">卫星</div>
				</div>
				<div class="tabs-item" v-show="mapSelectindex == 1" :class="[netSelectindex == 1 ? 'selected' : '']" @click="onselectNet()">
					<div class="iconfont icon-luwang"></div>
					<div class="item-rec">路网</div>
				</div>
				<div class="tabs-item" :class="[roadSelectindex == 1 ? 'selected' : '']" @click="onselectRoad()">
					<div class="iconfont icon-toggle"></div>
					<div class="item-rec">路况</div>
				</div>
			</div>
		</div>
		<div class="tab-content-tab">
			<div class="tabs-bg">
				<div class="tabs-item" :class="[labelState?'selected' : '']" @click="onToChangeLabel()">
					<div class="iconfont icon-duoyinzifenxi"></div>
					<div class="item-rec">名称</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['mapSelectindex', 'netSelectindex', 'roadSelectindex','tabList','selectIndex','labelState'],
		methods: {
			onselectMap() {
				this.$emit('onselectMap')
			},
			onselectNet() {
				this.$emit('onselectNet')
			},
			onselectRoad() {
				this.$emit('onselectRoad')
			},
			OntoTab(val){
				this.$emit('OntoTab',val)
			},
			onToChangeLabel(){
				this.$emit('onToChangeLabel')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.tab-top {
		position: absolute;
		top: 70px;
		left: 470px;
		z-index: 12;
		display: flex;

		.tab-content-tab,
		.tab-content-tabs {
			/* position: absolute;
			top: 70px;
			left: 655px; */
			display: flex;
			height: 30px;
			border-radius: 10px;
			background: #fff;
			display: flex;
			align-items: center;
			margin-left: 20px;

			.tabs-bg {
				height: 20px;
				display: flex;
				align-items: center;

				.selected {
					color: #0ff !important;
					// background: #0ff !important;
				}

				.tabs-item {
					// width: 130px;
					//width: 80px;
					height: 12px;
					background: none;
					display: flex;
					align-items: center;
					justify-content: center;
					color: #2c58a6;
					border-right: 1px dashed #ccc;
					cursor: pointer;
					user-select: none;
          padding: 0 10px;

					/* line-height: 30px;
				text-align: center;
				background: blue;
				transform: skewX(-45deg);
				display: flex;
				justify-content: center;
				color: #0ff;
				cursor: pointer; */
					&:last-child {
						border: none;
					}

					&:hover {
						opacity: 0.7;
					}

					.iconfont {
						font-size: 20px;
						margin-right: 5px;
					}

					.item-rec {
						// background: url('../../../../assets/others/index/tab-img-select.png') no-repeat;

						background-size: 100% 100%;
						height: 100%;
						line-height: 12px;
						font-size: 16px;
						text-align: center;
						font-weight: bold;
					}
				}

        .tabs-itemsss {
          // width: 130px;
          //width: 80px;
          height: 12px;
          background: none;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #2c58a6;
          border-right: 1px dashed #ccc;
          cursor: pointer;
          user-select: none;
          padding: 0 10px;

          /* line-height: 30px;
        text-align: center;
        background: blue;
        transform: skewX(-45deg);
        display: flex;
        justify-content: center;
        color: #0ff;
        cursor: pointer; */
          &:last-child {
            border: none;
          }

          &:hover {
            opacity: 0.7;
          }

          .iconfont {
            font-size: 20px;
            margin-right: 5px;
          }

          .item-rec {
            // background: url('../../../../assets/others/index/tab-img-select.png') no-repeat;

            background-size: 100% 100%;
            height: 100%;
            line-height: 12px;
            font-size: 16px;
            text-align: center;
            font-weight: bold;
          }
        }

			}
		}
	}
</style>
